module.exports = __webpack_public_path__ + "img/sportstradeleftsection.0cf93733.png";